/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdTagProps, TdCheckTagProps } from './type';

export const tagDefaultProps: TdTagProps = {
  closable: false,
  disabled: false,
  icon: undefined,
  shape: 'square',
  size: 'medium',
  theme: 'default',
  variant: 'dark',
};

export const checkTagDefaultProps: TdCheckTagProps = {
  defaultChecked: undefined,
  closable: false,
  disabled: false,
  shape: 'square',
  size: 'medium',
  variant: 'dark',
};
